import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/text2/page.tsx");
